/* eslint-ignore */
// @ts-nocheck
import styled, { css } from 'styled-components';

export const Container = styled.div`
  margin-top: 18px;
`;

export const TextDetailModel = styled.span``;

export const TextDetailModelHighlight = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 23px;
  color: #0013f5;
`;

export const ModelImgContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModelImg = styled.img`
  width: 80%;
  height: 80%;
`;

export const WrapButtons = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ArrowButton = styled.button`
  background: transparent;
  border: none;
  outline: none !important;
  display: flex;
  align-content: center;
  align-items: center;
  cursor: pointer;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 23px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #0013f5;

  ${({ disabledButton }) =>
    disabledButton &&
    css`
      color: #e5e5e5;
    `}
`;

export const BackButton = styled(ArrowButton)`
  svg {
    margin-right: 12px;
  }
`;

export const NextButton = styled(ArrowButton)`
  svg {
    margin-left: 12px;
  }
`;
